import { useData } from "./DataContext.js";

import Title from "./Title.js";
import SimCard from "./SimCard.js";

export default function TeacherMain ()
{
    const gData = useData();

    const ongoingSimCardList = Object
	.entries(gData.sim)
	.filter(([id, sim]) => sim.state === "ongoing")
	.sort(([id1, sim1], [id2, sim2]) => sim2.creationTime.localeCompare(sim1.creationTime))
	.map(([id, sim]) => (<SimCard key={sim.simID} simID={sim.simID}/>));

    const archivedSimCardList = Object
	.entries(gData.sim)
	.filter(([id, sim]) => sim.state === "archived")
	.sort(([id1, sim1], [id2, sim2]) => sim2.creationTime.localeCompare(sim1.creationTime))
	.map(([id, sim]) => (<SimCard key={sim.simID} simID={sim.simID}/>));

    return (
	<div className="d-flex flex-column gap-3 mb-5">
	    <div>
		{ongoingSimCardList.length === 0 ? (<Title>Aucune SIM en cours</Title>) : (<Title>SIM en cours</Title>)}
		<div className="d-flex flex-row flex-wrap justify-content-center gap-3">{ongoingSimCardList}</div>
	    </div>
	    <div>
		{archivedSimCardList.length === 0 ? (<Title>Aucune SIM archivée</Title>) : (<Title>SIM archivée{archivedSimCardList.length > 1 ? "s" : ""}</Title>)}
		<div className="d-flex flex-row flex-wrap justify-content-center gap-3">{archivedSimCardList}</div>
	    </div>
	</div>
    );
}
